export default "__VITE_ASSET__DYth0S6u__"